export default {
    down: {
        title: 'Πρόβλημα σύνδεσης με το athlisis',
        text: 'Προσπαθούμε να επανασυνδεθούμε αυτόματα. Μέχρι τότε, οι αλλαγές σου δεν αποθηκεύονται.',
    },
    restored: {
        title: 'Η σύνδεση αποκαταστάθηκε',
        text: 'Αν κάτι δεν φορτώθηκε σωστά, ανανέωσε τη σελίδα.',
    },
}
